import styled from 'styled-components'

export const Title = styled.h1``

export const WrapperDivergence = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  width: 70%;
`

export const WrapperHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 0;
`

export const Button = styled.button`
  outline-color: #002d63;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 10px 20px;
  color: #ffffff;
  font-weight: bold;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #25a37b')};
  cursor: pointer;
`
